/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement } from 'react';

import styles from './FormContainer.module.scss';
import vicLogo from '../images/fines-logo.jpg';
import { ReactComponent as Logo } from '../images/finesviclogo.svg';
import { ReactComponent as CloseIcon } from '../images/close.svg';

interface iLink {
  text: string;
  url: string;
}
interface iFooterLinks {
  title: string;
  links: iLink[];
}

interface iProps {
  title: string;
  children: any;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function FormContainer({ title, children }: iProps): ReactElement {
  const paths = window.location.pathname.split('/');
  const isErrorPage = paths[paths.length - 1].includes('error');
  const footerLinks: iFooterLinks[] = [
    {
      title: 'About Us',
      links: [
        { text: 'About Fines Victoria', url: 'www.google.com' },
        { text: 'Roles and responsibilities', url: 'www.google.com' },
        { text: 'News', url: 'www.google.com' },
      ],
    },
    {
      title: 'About our site',
      links: [
        { text: 'Terms of use', url: 'www.google.com' },
        { text: 'Privacy', url: 'www.google.com' },
        { text: 'Copyright', url: 'www.google.com' },
        { text: 'Accessibility', url: 'www.google.com' },
        { text: 'Web browser support', url: 'www.google.com' },
        { text: 'Sitemap', url: 'www.google.com' },
      ],
    },
    {
      title: 'Resources',
      links: [
        { text: 'Legal and financal assistance', url: 'www.google.com' },
        { text: 'Languages', url: 'www.google.com' },
      ],
    },
    {
      title: 'Connect with us',
      links: [
        { text: 'Contact us', url: 'www.google.com' },
        { text: 'Feedback and complaints', url: 'www.google.com' },
      ],
    },
  ];

  if (process.env.NODE_ENV !== 'development') {
    return <div className={styles.formContainer}>{children}</div>;
  }

  return (
    <div className={styles.componentContainer}>
      <div className={styles.header}>
        <div className={styles.headerBg} />
        <div className={styles.logoContainer}>
          <a href="/">
            <Logo className={styles.logo} />
          </a>
        </div>
        <div className={styles.title}>{title}</div>
        {/* Ensure to either surround with button or add aria labels for non standard button */}
        <div className={styles.vfbuttonContainer}>
          <div className={styles.vfbutton}>
            <div className={styles.mobile}>Quick exit</div>
            <div className={styles.tabletAbove}>Quick exit</div>
            <svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" className={styles.closeIcon} xmlns="http://www.w3.org/2000/svg">
              <title>Quick exit</title>
              <g id="Quick exit" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="np_esc_3803623_000000" transform="translate(13.000000, 13.000000)" fill="#FFFFFF" fillRule="nonzero">
                  <path d="M16.7575416,18 L1.24245836,18 C0.55773671,18 0,17.4433199 0,16.7575416 L0,1.24245836 C0,0.55773671 0.556680083,0 1.24245836,0 L16.7575416,0 C17.4422633,0 18,0.556680083 18,1.24245836 L18,16.7575416 C18,17.4422633 17.4422633,18 16.7575416,18 Z M1.24245836,0.846873316 C1.02444361,0.846873316 0.846656572,1.0246712 0.846656572,1.2426751 L0.846656572,16.7577584 C0.846656572,16.9757731 1.02445445,17.1535602 1.24245836,17.1535602 L16.7575416,17.1535602 C16.9755564,17.1535602 17.1533434,16.9757623 17.1533434,16.7577584 L17.1533434,1.2426751 C17.1533434,1.02466036 16.9755455,0.846873316 16.7575416,0.846873316 L1.24245836,0.846873316 Z" id="Shape" />
                  <polygon id="Path" points="7.06745557 8.51013128 4.88096836 8.51013128 4.88096836 10.5378805 7.31722604 10.5378805 7.31722604 11.1474733 4.15384615 11.1474733 4.15384615 5.52242248 7.19232726 5.52242248 7.19232726 6.13095858 4.88096836 6.13095858 4.88096836 7.90893738 7.06745557 7.90893738" />
                  <path d="M8.1332946,10.3960757 C8.35025001,10.5378914 8.73443431,10.6881655 9.10165297,10.6881655 C9.63611679,10.6881655 9.88691679,10.4214673 9.88691679,10.0870258 C9.88691679,9.73671314 9.67842794,9.54516555 9.13551924,9.34408123 C8.40950784,9.08585233 8.06767533,8.68474573 8.06767533,8.20108131 C8.06767533,7.55022593 8.59365903,7.01576211 9.46147524,7.01576211 C9.86998365,7.01576211 10.2287493,7.13217807 10.4552469,7.26658378 L10.2700418,7.8010476 C10.111293,7.70156477 9.81918697,7.56715906 9.44454482,7.56715906 C9.01062317,7.56715906 8.76827619,7.8169241 8.76827619,8.11747228 C8.76827619,8.45085177 9.00957196,8.60219333 9.53555024,8.8011373 C10.2361484,9.06783548 10.5959978,9.41918306 10.5959978,10.0203228 C10.5959978,10.729401 10.0446008,11.2299715 9.08577918,11.2299715 C8.64340451,11.2299715 8.2348961,11.1209655 7.95020275,10.9548149 L8.1332946,10.3960757 Z" id="Path" />
                  <path d="M14.4164346,10.9969987 C14.2248789,11.0964815 13.7983889,11.2308872 13.2565287,11.2308872 C12.0383998,11.2308872 11.2457125,10.4043337 11.2457125,9.16927171 C11.2457125,7.92575672 12.0965956,7.02404715 13.4152666,7.02404715 C13.8491883,7.02404715 14.2333401,7.13305317 14.4333678,7.232536 L14.2661524,7.79980945 C14.0904705,7.70032662 13.8152976,7.6071944 13.4152693,7.6071944 C12.4892302,7.6071944 11.9886598,8.29191605 11.9886598,9.13434611 C11.9886598,10.0688382 12.5897995,10.6445647 13.3909398,10.6445647 C13.8079283,10.6445647 14.0841416,10.5355587 14.2926223,10.4434831 L14.4164346,10.9969987 Z" id="Path" />
                </g>
              </g>
            </svg>
          </div>
          <div className={styles.hoverTextTop}>
            <span>
              <strong>To leave this site quickly and be taken to Google, click this button or the Escape button on your keyboard. You should also clear your browser history.</strong>

            </span>
          </div>
        </div>
      </div>
      <div className={isErrorPage ? styles.formContainerError : styles.formContainer}>{children}</div>
      <div className={styles.formFooter}>
        <div className={styles.linksContainer}>
          {footerLinks.map((linkgroup: iFooterLinks) => (
            <div key={linkgroup.title}>
              <div className={styles.linkGroupTitle}>
                <b>{linkgroup.title}</b>
              </div>
              {linkgroup.links.map((link: iLink) => (
                <a key={link.text} href={link.url}>
                  {link.text}
                </a>
              ))}
            </div>
          ))}
          <div className={styles.footerImage}>
            <img src={vicLogo} alt="Victoria Logo" />
          </div>
        </div>
        <div className={styles.metainfoContainer}>
          <div>© State Government of Victoria</div>
          <div>Last Updated: 8/2/2016 </div>
        </div>
      </div>
    </div>
  );
}

export default FormContainer;
